import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isNull } from 'lodash-es';
import { apiRootFeatureState, ApiRootState } from './api-root.reducer';

export const selectFeature = createFeatureSelector<ApiRootState>(apiRootFeatureState);

export const apiRootSelector = createSelector(selectFeature, (state: ApiRootState) => state?.apiRoot);

export const apiRootIsLoadedSelector = createSelector(apiRootSelector, apiRoot => !isNull(apiRoot));
